<template>
  <div class="wrapBox" style=" padding-left:8px;padding-right:4px;padding-top:8px;">
    <div class="myChartTitleWrap">
      <div class="myChartTitle">{{titleText}}</div>
    </div>
    <div id="myChinaMap" :style="{width: '100%', height: '528px'}">
    </div>
  </div>
</template>

<script>
  // 主模块
  let echarts = require('echarts/lib/echarts')
  // 散点图
  require('echarts/lib/chart/scatter')
  // 散点图放大
  require('echarts/lib/chart/effectScatter')
  // 地图
  require('echarts/lib/chart/map')
  // 图例
  require('echarts/lib/component/legend')
  // 提示框
  require('echarts/lib/component/tooltip')
  // 地图geo
  require('echarts/lib/component/geo')

  require('echarts/map/js/china')
  
  export default {
    name: 'ChinaMap',
    props: ['mainPageData'],
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        titleText: '中国-中东欧进出口分布（截至'+ this.mainPageData.dataEnd +'）',
        textStyle: {color:'#ccc', fontStyle:'normal', fontWeight:'bold', fontFamily:'sans-serif', fontSize:12 },
        legendPadding: [65, 5, 15, 5],
        myData2: [{
          "amount": 1051512.63,
          "destinationPort": "12",
          "mainGoods": "发光二极管,铬矿砂及其精矿",
          "province": "天津市",
          "qty": 1154049610
        },{
          "amount": 1991561.44,
          "destinationPort": "37",
          "mainGoods": "铝矿砂及其精矿,用塑料或橡胶浸/涂或包覆的针织或钩编手套",
          "province": "山东省",
          "qty": 2194704632
        },{
          "amount": 4919566.24,
          "destinationPort": "31",
          "mainGoods": "二极管,但光敏二极管或发光二极管除外,其他电感器",
          "province": "上海市",
          "qty": 1369591057
        }, {
          "amount": 6391110.97,
          "destinationPort": "32",
          "mainGoods": "其他电感器,注射器,不论是否装有针头",
          "province": "江苏省",
          "qty": 4008436884
        }, 
        {
          "amount": 8152883.58,
          "destinationPort": "44",
          "mainGoods": "发光二极管,二极管,但光敏二极管或发光二极管除外",
          "province": "广东省",
          "qty": 4318516906
        }, 
        {
          "amount": 6219559.22,
          "destinationPort": "33",
          "mainGoods": "圆珠笔,棉制其他袜",
          "province": "浙江省",
          "qty": 5224703517
        }
        ],
        myData: [{
          "amount": 1672113.93,
          "destinationPort": "11",
          "mainGoods": "水青冈木(山毛榉木)木材,经纵锯/纵切/刨切或旋切,厚＞6mm,未锻轧铜含量＞99.9935%的精炼铜阴极",
          "province": "北京市",
          "qty": 225510944
        }, {
          "amount": 1051512.63,
          "destinationPort": "12",
          "mainGoods": "发光二极管,铬矿砂及其精矿",
          "province": "天津市",
          "qty": 1154049610
        }, {
          "amount": 498869.79,
          "destinationPort": "13",
          "mainGoods": "铝矿砂及其精矿,锰矿砂及其精矿",
          "province": "河北省",
          "qty": 526342118
        }, {
          "amount": 224518.20,
          "destinationPort": "14",
          "mainGoods": "铬矿砂及其精矿,耐火粘土",
          "province": "山西省",
          "qty": 94927867
        }, {
          "amount": 37595.74,
          "destinationPort": "15",
          "mainGoods": "硫酸铵,其他氨基醇酚/氨基酸酚及其他含氧基氨基化合物",
          "province": "内蒙古",
          "qty": 53015423
        }, {
          "amount": 1107173.71,
          "destinationPort": "21",
          "mainGoods": "栎木(橡木)原木,熔凝镁氧矿",
          "province": "辽宁省",
          "qty": 447005450
        }, {
          "amount": 1410928.18,
          "destinationPort": "22",
          "mainGoods": "化学木浆/溶解级,棉制其他袜",
          "province": "吉林省",
          "qty": 92709035
        }, {
          "amount": 88554.93,
          "destinationPort": "23",
          "mainGoods": "含亚麻≥85％漂白的布,纵锯切刨或旋切其他温带非针叶木材,厚＞6mm",
          "province": "黑龙江",
          "qty": 33629133
        }, {
          "amount": 4919566.24,
          "destinationPort": "31",
          "mainGoods": "二极管,但光敏二极管或发光二极管除外,其他电感器",
          "province": "上海市",
          "qty": 1369591057
        }, {
          "amount": 6391110.97,
          "destinationPort": "32",
          "mainGoods": "其他电感器,注射器,不论是否装有针头",
          "province": "江苏省",
          "qty": 4008436884
        }, {
          "amount": 6219559.22,
          "destinationPort": "33",
          "mainGoods": "圆珠笔,棉制其他袜",
          "province": "浙江省",
          "qty": 5224703517
        }, {
          "amount": 561069.61,
          "destinationPort": "34",
          "mainGoods": "注射器,不论是否装有针头,其他针/导管/插管及类似品",
          "province": "安徽省",
          "qty": 283415089
        }, {
          "amount": 1720330.02,
          "destinationPort": "35",
          "mainGoods": "未列名已加工花岗岩制品,冷杉和云杉原木,截面尺寸≥15cm",
          "province": "福建省",
          "qty": 951558896
        }, {
          "amount": 253414.97,
          "destinationPort": "36",
          "mainGoods": "其他聚乙烯/聚丙烯扁条等材料制货物包装袋,棉制其他袜",
          "province": "江西省",
          "qty": 300520249
        }, {
          "amount": 1991561.44,
          "destinationPort": "37",
          "mainGoods": "铝矿砂及其精矿,用塑料或橡胶浸/涂或包覆的针织或钩编手套",
          "province": "山东省",
          "qty": 2194704632
        }, {
          "amount": 637106.09,
          "destinationPort": "41",
          "mainGoods": "人工合成的钻石粉末,棕刚玉",
          "province": "河南省",
          "qty": 206072119
        }, {
          "amount": 586414.25,
          "destinationPort": "42",
          "mainGoods": "针织的帽类及用成匹的花边/毡呢或其他纺织物制成的帽类,未列名已加工花岗岩制品",
          "province": "湖北省",
          "qty": 439883252
        }, {
          "amount": 201367.35,
          "destinationPort": "43",
          "mainGoods": "袖珍气体打火机,可充气的,人工合成的钻石粉末",
          "province": "湖南省",
          "qty": 175318624
        }, {
          "amount": 8152883.58,
          "destinationPort": "44",
          "mainGoods": "发光二极管,二极管,但光敏二极管或发光二极管除外",
          "province": "广东省",
          "qty": 4318516906
        }, {
          "amount": 109129.67,
          "destinationPort": "45",
          "mainGoods": "未焙烧的黄铁矿,铬矿砂及其精矿",
          "province": "广西",
          "qty": 116485977
        }, {
          "amount": 23651.17,
          "destinationPort": "46",
          "mainGoods": "含氮/磷/钾三种元素的矿物肥料或化学肥料,泥煤(包括肥料用泥煤),不论是否制成型",
          "province": "海南省",
          "qty": 7604918
        }, {
          "amount": 531305.94,
          "destinationPort": "50",
          "mainGoods": "铬矿砂及其精矿,二极管,但光敏二极管或发光二极管除外",
          "province": "重庆市",
          "qty": 97936015
        }, {
          "amount": 524378.26,
          "destinationPort": "51",
          "mainGoods": "二极管,但光敏二极管或发光二极管除外,耗散功率＜1瓦的晶体管",
          "province": "四川省",
          "qty": 270768472
        }, {
          "amount": 31478.27,
          "destinationPort": "52",
          "mainGoods": "袖珍气体打火机,可充气的,铝矿砂及其精矿",
          "province": "贵州省",
          "qty": 23738706
        }, {
          "amount": 31526.71,
          "destinationPort": "53",
          "mainGoods": "泥煤(包括肥料用泥煤),不论是否制成型,部分或全部去梗的烤烟",
          "province": "云南省",
          "qty": 21244362
        }, {
          "amount": 972.33,
          "destinationPort": "54",
          "mainGoods": "其他氨基醇酚/氨基酸酚及其他含氧基氨基化合物,制成的饲料添加剂",
          "province": "西藏",
          "qty": 1170057
        }, {
          "amount": 204475.13,
          "destinationPort": "61",
          "mainGoods": "袖珍气体打火机,可充气的,带充气系统的安全气囊及其零件",
          "province": "陕西省",
          "qty": 19809807
        }, {
          "amount": 34269.83,
          "destinationPort": "62",
          "mainGoods": "炉用碳电极,其他非合金铝矩形板/片,厚度＞0.2mm",
          "province": "甘肃省",
          "qty": 8753352
        }, {
          "amount": 1246.16,
          "destinationPort": "63",
          "mainGoods": "铬矿砂及其精矿,其他非合金铝矩形板/片,厚度＞0.2mm",
          "province": "青海省",
          "qty": 1363166
        }, {
          "amount": 25037.08,
          "destinationPort": "64",
          "mainGoods": "锰矿砂及其精矿,其他氨基醇酚/氨基酸酚及其他含氧基氨基化合物",
          "province": "宁夏",
          "qty": 42352724
        }, {
          "amount": 36738.71,
          "destinationPort": "65",
          "mainGoods": "番茄酱罐头重量＞5kg,赖氨酸酯及盐",
          "province": "新疆",
          "qty": 44439732
        }],
        geoCoordMap: {
          '北京市': [116.389, 39.9488],
          '天津市': [117.347, 39.3708],
          '河北省': [115.314, 38.5205],
          '山西省': [112.389, 37.7586],
          '内蒙古': [111.623, 41.5938],
          '辽宁省': [123.07, 41.386],
          '吉林省': [126.466, 43.2978],
          '黑龙江': [127.97, 46.8451],
          '上海市': [121.409, 31.0909],
          '江苏省': [119.942, 32.9844],
          '浙江省': [120.219375, 30.259244],
          '安徽省': [117.282699, 31.866942],
          '福建省': [118.103886, 24.489231],
          '江西省': [115.893528, 28.689578],
          '山东省': [117.024967, 36.682785],
          '河南省': [113.649644, 34.75661],
          '湖北省': [114.3162, 30.581084],
          '湖南省': [112.979353, 28.213478],
          '广东省': [113.30765, 23.120049],
          '广西': [108.297234, 22.806493],
          '海南省': [110.330802, 20.022071],
          '重庆市': [106.530635, 29.544606],
          '四川省': [104.067923, 30.679943],
          '贵州省': [106.709177, 26.629907],
          '云南省': [102.714601, 25.049153],
          '西藏': [91.111891, 29.662557],
          '陕西省': [108.953098, 34.2778],
          '甘肃省': [103.823305, 36.064226],
          '青海省': [101.767921, 36.640739],
          '宁夏': [106.206479, 38.502621],
          '新疆': [87.564988, 43.84038],
        },
      }
    },
    mounted() {
      this.drawLine();
    },
    computed: {
      opt() {
        let that = this;
        let obj = {
          tooltip: {
            trigger: 'item',
            formatter: function(params) {
              // console.log(params);
              return params.name + ' : ' + params.value[2] + '亿元';
            }
          },
          legend: {
            orient: 'vertical',
            y: 'bottom',
            x: 'right',
            data: ['pm2.5'],
            textStyle: {
              color: '#fff'
            }
          },
          geo: {
            map: 'china',
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: { // 定义样式
              normal: { // 普通状态下的样式
                areaColor: '#323c48',
                borderColor: '#111'
              },
              emphasis: { // 高亮状态下的样式
                areaColor: '#2a333d'
              }
            },
  
          },
  
          //backgroundColor: '#112233',
          backgroundColor: '#21232c',
          series: [{
              name: '销量', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data: that.convertData3(this.mainPageData.heatMapList),
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
            },
            {
              name: 'Top 5',
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: that.convertData3(this.mainPageData.heatMapList),
              symbolSize: function (val) {
                // console.log('a', val)
                return 15;
            },
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke'
              },
              hoverAnimation: true,
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'left',
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#f4e925',
                  shadowBlur: 10,
                  shadowColor: '#333'
                }
              },
              zlevel: 1
            }
          ],
          visualMap: {
            type: 'continuous', // 连续型
            calculable:false,
            align:"left",    
            min: 0, // 值域最小值，必须参数
            max: 200, // 值域最大值，必须参数
            calculable: true, // 是否启用值域漫游
            inRange: {
              color: ['#50a3ba', '#eac736', '#d94e5d']
              // 指定数值从低到高时的颜色变化
            },
            textStyle: {
              color: '#fff' // 值域控件的文本颜色
            },
            formatter: function (value) {                 //标签的格式化工具。
              return value + '亿元';                    // 范围标签显示内容。
            }
          }
  
        };
        return obj;
      }
    },
    methods: {
      convertData() {
        //this.myData = this.myData.sort();
        var res = [];
        for (var i = 0; i < this.myData.length; i++) {
          var geoCoord = this.geoCoordMap[this.myData[i].province];
          if (geoCoord) {
              var number = this.myData[i].qty / 100000000;
              number = String(number).replace(/^(.*\..{4}).*$/,"$1");
              number = Number(number);
              res.push({
              name: this.myData[i].province,
              value: geoCoord.concat(number)
            });
          }
        }
        //console.log('ppp', res);
        return res;
  
      },
      convertData2() {
        //this.myData = this.myData.sort();
        var res = [];
        for (var i = 0; i < this.myData2.length; i++) {
          var geoCoord = this.geoCoordMap[this.myData2[i].province];
          if (geoCoord) {
            var number = this.myData2[i].qty / 100000000;
              number = String(number).replace(/^(.*\..{4}).*$/,"$1");
              number = Number(number);
            res.push({
              name: this.myData2[i].province,
              value: geoCoord.concat(number)
            });
          }
        }
        return res;
  
      },
      convertData3(data) {
        //this.myData = this.myData.sort();
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = this.geoCoordMap[data[i].value1];
          if (geoCoord) {
            res.push({
              name: data[i].value1,
              value: geoCoord.concat(data[i].value)
            });
          }
        }
        return res;
  
      },
      drawLine() {
        let myChinaMap = this.$echarts.init(document.getElementById('myChinaMap'));
        myChinaMap.setOption(this.opt);
      }
    }
  
  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/ChinaMap.vue